import $api from '@/handler/axios'
import Vue from 'vue'




export const CHECK_AUTH = 'CHECK_AUTH'
export const SET_USER = 'SET_USER'

const state = {
  authenticated: false,
  user: null
}

const mutations = {
  [CHECK_AUTH] (state, value) {
    state.authenticated = value
  },
  [SET_USER] (state, value) {
    state.user = value
  }
}

const actions = {
  register (context, formData) {
    return new Promise((resolve, reject) => {
      $api.post('authuser/signup/', formData).then(res => {
        Vue.auth.setToken(res)
        resolve(res)
      }).catch(err => {
        reject(err)
      })
    })
  },
  login (context, formData) {
    return new Promise((resolve, reject) => {
      $api.post('authuser/login/', formData).then(res => {
        const token = res.data.token
        localStorage.setItem('token', token)
        resolve(res)
      }).catch(err => {
        reject(err)
      })
    })
  },
  logout () {
    return new Promise((resolve, reject) => {
      Vue.auth.destroyToken()
      resolve()
    })
  }
}

/*
|--------------------------------------------------------------------------
| Getters
|--------------------------------------------------------------------------
*/
const getters = {
  authenticated: state => state.authenticated,
  user: state => state.user
}

/*
|--------------------------------------------------------------------------
| Export the module
|--------------------------------------------------------------------------
*/
export default {
  state,
  mutations,
  actions,
  getters
}
